import { Component, OnInit } from '@angular/core';

declare var $: any;

@Component({
  selector: 'app-ecatalogusFR',
  templateUrl: '../../../../assets/html/fabrikanten_ecatalogusFR.html',
  styleUrls: ['./ecatalogusFR.component.css']
})
export class EcatalogusFRComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    var t = $('[data-parallax="scroll"]').data('imageSrc');
    $('[data-parallax="scroll"]').parallax({imageSrc: t});
  }

}
